import React from 'react';
import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';

export default function RightDrawer({ open, onClose, children, width = '25vw' }) {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { width: width, maxWidth: '100vw' },
      }}
    >
      <Box sx={{ width: '100%', height: '100%' }}>
        {children}
      </Box>
    </Drawer>
  );
} 